import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { isNullOrUndefined } from '.';
import { MLHelper } from '../locales/MLHelper';
import { toLowerCase } from './toLowerCase';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);

interface IcompareMatchWithCollectionArgs {
	value: any;
	compareValue: any;
	dataType: string;
	format?: string;
	editType?: string;
}

export default function compareMatchWithCollection({
	value,
	compareValue,
	dataType,
	format,
	editType
}: IcompareMatchWithCollectionArgs) {
	if (isNullOrUndefined(value) || isNullOrUndefined(compareValue)) {
		return false;
	}

	switch (dataType) {
		case 'datetime':
			const datetimeDay = dayjs(value).isSame(dayjs(compareValue), 'day');
			const datetimeHour = dayjs(value).isSame(dayjs(compareValue), 'hour');
			const datetimeMinute = dayjs(value).isSame(dayjs(compareValue), 'minute');
			return datetimeDay && datetimeHour && datetimeMinute;
		case 'date':
			return dayjs(value).isSame(compareValue, 'day');
		case 'time':
			const left = dayjs(value).format(format || 'HH:mm:ss');
			const right = dayjs(compareValue).format(format || 'HH:mm:ss');

			return left === right;
		case 'boolean':
			return value.toString() === toLowerCase(compareValue.toString());
		case 'multiLanguage': {
			return MLHelper.getMLText(value) === MLHelper.getMLText(compareValue);
		}
		case 'object': {
			if (editType == 'multiLanguageTextBox') {
				return MLHelper.getMLText(value) === MLHelper.getMLText(compareValue);
			}

			return MLHelper.getMLText(value?.text) === compareValue;
		}
		default:
			return value == compareValue;
	}
}
